import React from 'react';
import CheckoutForm from './checkout_form/form';
import css from "./style.scss"
import store from 'utils/store'
import cn from 'classnames';
import api from './api'
import analytics from 'utils/analytics'
import CustomPlansUI from './ui/custom_plans'
import NormalPlansUI from './ui/normal_plans'
import Plans from '../../../shared/plans'
import SuccessPopup from './ui/success_popup'
import LoadingPopup from './ui/loading_popup'

class PremiumPlans extends React.Component {
  constructor(props){
    super(props)
    this.state={
      loading:false,
      open_success_popup:false,
      selected_period:"monthly",
      selected_plan:undefined
    }
  }
  handleFormSubmit=()=>{
    this.setState({loading:true})
  }
  onError=()=>{
    this.setState({loading:false})
  }
  getCurrentPlan=()=>{
    return Plans[this.props.mode][this.state.selected_period][this.state.selected_plan]
  }
  handleToken=({stripeObject, coupon})=>{
    let planId=this.getCurrentPlan().id
    if(coupon==="test-day"){
      coupon=undefined
      planId="test-day"
    }
    let obj={
      stripeObject,
      coupon,
      plan:planId,
    }
    api.saveSubscription(obj).then(result=>{
      if(result.err){
        store.dispatch({type:"ADD_TOAST", message:result.err.message})
        this.setState({loading:false})
      }else{
        analytics.track("become_premium")
        this.setState({loading:false, open_success_popup:true})
        store.dispatch({type:"UPDATE_USER", payload:result})
      }
    })
  }

  handleSelectPlan=(plan)=>{
    this.setState({selected_plan: plan})
  }
  changePeriod=()=>{
    this.setState({selected_period: this.state.selected_period==="monthly" ? "yearly" : "monthly"})
  }
  handleClose=()=>{
    if(this.props.backTo){
      this.props.backTo()
    }else{
      this.setState({open_success_popup:false})
    }
  }
  renderPlans(){
    if(this.props.mode==="custom"){
      return (
        <CustomPlansUI
          selectedPeriod={this.state.selected_period}
          selectedPlan={this.state.selected_plan}
          settings={false}
          plans={Plans.custom}
          onSelect={this.handleSelectPlan}
          onChangePeriod={this.changePeriod}
        />
      )
    }else{
      return (
        <NormalPlansUI
          plans={Plans.normal}
          selectedPeriod={this.state.selected_period}
          selectedPlan={this.state.selected_plan}
          settings={this.props.settings}
          onSelect={this.handleSelectPlan}
          onChangePeriod={this.changePeriod}
        />
      )
    }
  }
  render() {
    return (
      <div>
        {this.renderPlans()}
        <div className={cn(css.sidebar, this.props.mode==="custom" ? css.sidebarMargin : "")}>
            <CheckoutForm onError={this.onError} onSubmit={this.handleFormSubmit} onSuccessTokenCreation={this.handleToken}/>
        </div>
        {this.state.open_success_popup && <SuccessPopup onClose={this.handleClose} plan={this.getCurrentPlan()}/>}
        {this.state.loading && <LoadingPopup/>}
      </div>
    )
  }
}
PremiumPlans.defaultProps={
  settings: false,
  mode:"normal"
}

export default PremiumPlans;



// WEBPACK FOOTER //
// ./src/components/subscriptions/modal/premium_plans.js